import gsap from "gsap";

(function ($) {

    function startAnimationNumbers () {
        const items = document.querySelectorAll(".section-image-banner-values .number");
        if (items.length > 0) {
        gsap.from(items, {
            textContent: 0,
            duration: 4,
            ease: "Power1.easeIn",
            snap: { textContent: 1 },
            stagger: {
                each: 1,
            }
        });}
    }


    let animationTriggered = false;
    $(window).on('scroll', function() {
        const $section = $('.section-image-banner-values');
        const sectionTop = $section.offset().top;
        const triggerPoint = $(window).scrollTop() + $(window).height() / 1.5;

        // Check if animations should be triggered
        if (!animationTriggered && sectionTop < triggerPoint) {
            startAnimationNumbers();
            animationTriggered = true; // Set flag to prevent re-triggering
        }
    });


})(jQuery);